module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"schedules":"Horaires","stopover":"Escales","companies":"Compagnies"},"en":{"schedules":"Schedules","stopover":"Stopovers","companies":"Companies"}}')
  delete Component.options._Ctor
}
